import timeoutProm from "utils/promise/promiseTimeout";
import * as eventTypes from "actions/eventTypes";

let correlationIds = new Map();

const waitForEvent = (correlationId, eventNames = [], timeout = 58000) => {
  let outResolve, outReject;
  let prom = new Promise((resolve, reject) => {
    outResolve = resolve;
    outReject = reject;
  });
  correlationIds.set(correlationId, { eventNames, resolver: { outResolve, outReject } });
  return timeoutProm(prom, timeout);
};

export function onReceiveEvent(event) {
  if (correlationIds.has(event.correlationId)) {
    let cmd = correlationIds.get(event.correlationId);

    // if (event.eventType.endsWith('Error'))
    //     cmd.resolver.outReject(event);
    // else
    if (cmd.eventNames.indexOf(event.eventType) > -1) cmd.resolver.outResolve({ ...event, ok: true });
    if (
      event.eventType.indexOf(eventTypes.COMMAND_EXECUTION_ERROR) > -1 ||
      event.eventType.indexOf(eventTypes.COMMAND_VALIDATION_ERROR) > -1 ||
      event.eventType.indexOf(eventTypes.TASKS_COMMAND_EXECUTION_ERROR) > -1
    )
      cmd.resolver.outResolve({ ...event, ok: false });
    if (cmd.eventNames.length === 0) cmd.resolver.outResolve({ ...event, ok: true });
  }
}

export default waitForEvent;
